module.exports = __webpack_public_path__ + "static/media/icon-8.ad634170.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mm/icon-8.png
// module id = 2559
// module chunks = 0